import {Grid, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {equals, flow, get} from '@yandex-delivery/utils'
import {type ReactElement, useRef} from 'react'

import {AddressProvider} from '../../contexts/AddressContext'
import {matchSection} from '../../lib/matchSection'
import {Verticals} from '../../widgets/Verticals/index@desktop'
import {ActionButtonWidget} from '../ActionButton/index@desktop'
import {renderWidget} from '../index@desktop'
import {PaymentMethodWidget} from '../PaymentMethod/index@desktop'
import {
  type ActionButtonWidgetConfig,
  type FormWidgetProps as Props,
  type PaymentMethodWidgetConfig,
  type WidgetConfig,
  WidgetType,
} from '../types'
import * as classes from './index@desktop.classes'
import {segmentMock, verticalsMock} from './mocks'

export function FormWidget(props: Props): ReactElement {
  const {sections, bottom_section: bottomSection} = props.config
  const sentinelRef = useRef<HTMLDivElement>(null)

  return (
    <AddressProvider>
      {/*{header_section && (*/}
      {/*  <Paper className={classes.headerSection} padding="none" radius="L" noOverflow>*/}
      {/*    {header_section.widgets.map(renderWidget)}*/}
      {/*  </Paper>*/}
      {/*)}*/}

      <Grid size="s" container>
        {sections.map((section, index) => {
          const key = `.section.${index}`

          const IdSpecificComponent = matchSection(section)
          if (IdSpecificComponent) {
            if (IdSpecificComponent === Verticals)
              return (
                <IdSpecificComponent
                  key={key}
                  section={{widgets: [segmentMock, verticalsMock, ...section.widgets.slice(1)]}}
                />
              )
            return <IdSpecificComponent key={key} section={section} />
          }

          return (
            <Grid key={key} xs={12} item>
              <Paper radius="L">
                {section.widgets.map((widget, sectionIndex) => renderWidget(widget, `${key}.widget.${sectionIndex}`))}
              </Paper>
            </Grid>
          )
        })}

        {bottomSection?.widgets.reduce<ReactElement[]>((acc, widget, index) => {
          const id = widget.widget_id || index
          const key = `.bottom_section.widget.${id}`

          if (isPaymentMethodWidget(widget)) {
            acc.push(
              <Grid key={key} xs={12} item>
                <PaymentMethodWidget config={widget} />
                <div ref={sentinelRef} />
              </Grid>,
            )
          }

          if (isActionButtonWidget(widget)) {
            acc.push(
              <Grid key={key} className={classes.actionButton} xs={12} item>
                <ActionButtonWidget config={widget} sentinelRef={sentinelRef} />
              </Grid>,
            )
          }

          return acc
        }, [])}
      </Grid>
    </AddressProvider>
  )
}

const isPaymentMethodWidget = flow(
  get('type'), //
  equals(WidgetType.PAYMENT_METHOD),
) as (widget: WidgetConfig) => widget is PaymentMethodWidgetConfig
const isActionButtonWidget = flow(
  get('type'), //
  equals(WidgetType.ACTION_BUTTON),
) as (widget: WidgetConfig) => widget is ActionButtonWidgetConfig
